export default {
    clickToCopy: '申込リンクをコピーする',
    fifthListImportInvoices: '請求書、会計および支払のデータ出力（CSV）',
    findOutMoreLink:
        '<0>こちら</0>からサービス詳細の確認や、デモ・トライアルをお申込みいただけます。',
    firstListElementStarterPlan: '無料で利用可能（機能制限あり）',
    firstListImportInvoices: '受領請求書を一覧で確認',
    forRicohTradeAutomationUsers: 'ご利用中のお客様',
    fourthListImportInvoices: '請求書の仕訳情報入力',
    goButton: 'アプリを起動',
    inviteParagraph:
        'まだMakeLeapsアカウントをお持ちではない仕入先を「スタータープラン」に招待できます。下記のボタンよりスターター申込ページへのリンクをコピーし、仕入れ先と共有してください。',
    listImportInvoicesTitle:
        'MakeLeapsのセキュア受信箱に受信した請求書を取り込み、次のことが可能です。',
    listStarterPlanTitle: 'スタータープランの特徴',
    logInToRicohTradeAutomation: 'RICOH Trade Automation にログイン',
    paragraphThinkingAboutRicohTradeAutomation:
        'RICOH Trade Automation（別契約）は、MakeLeaps と連携することで、 購入側企業の発注・受領請求処理業務と企業間ワークフローのデジタル化が可能となるサービスです。',
    secondListElementStarterPlan: '注文請書、請求書などの各種書類が発行可能',
    secondListImportInvoices: '請求書内容の確認',
    signPageForVendors: '仕入先用MakeLeaps申込ページ',
    subtitle:
        'MakeLeapsの受領請求書を取り込み、注文書との自動照合、会計システムや銀行支払システムと連携するデータの生成ができます。',
    thirdListElementStarterPlan: '請求書の統合が可能',
    thirdListImportInvoices: 'MakeLeapsから送付した発注書との自動照合',
    title: 'RICOH Trade Automation',
    titleThinkingAboutRicohTradeAutomation: 'ご検討中のお客様',
};
